// removed by extract-text-webpack-plugin
module.exports = {"graphic":"graphic_1kkL5"};


//////////////////
// WEBPACK FOOTER
// ./app/components/graphic/styles.scss
// module id = 434
// module chunks = 1